/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantOrgCapabilitiesFleetManagement } from './tenantOrgCapabilitiesFleetManagement';
import { TenantOrgCapabilitiesAccess } from './tenantOrgCapabilitiesAccess';
import { TenantOrgCapabilitiesDeployments } from './tenantOrgCapabilitiesDeployments';
import { TenantOrgCapabilitiesCommerce } from './tenantOrgCapabilitiesCommerce';


export interface TenantOrgCapabilitiesVmcfs { 
    deployments?: TenantOrgCapabilitiesDeployments;
    access?: TenantOrgCapabilitiesAccess;
    commerce?: TenantOrgCapabilitiesCommerce;
    fleet_management?: TenantOrgCapabilitiesFleetManagement;
}

